import styled from "styled-components";
import { breakpoints } from "styles";

export const Wrapper = styled.div`
  border-radius: 8px;
  padding: 16px;
  background-color: ${({ theme }) => theme.colors.yellow["100"]};
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;

  @media ${breakpoints.tablet} {
    border-radius: 16px;
    padding: 24px 32px;
    gap: 32px;
  }
`;

export const Heading = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 700;
  line-height: 22px;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["3xl"]};
    line-height: 40px;
  }
`;

export const Description = styled.p`
  margin: 8px 0 0;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  text-align: center;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes.xl};
    line-height: 30px;
  }
`;

export const ScheduleContainer = styled.div`
  display: flex;
`;

export const Schedule = styled.div`
  padding: 0 8px;
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 8px;

  &:first-child {
    padding-left: 0px;
  }

  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.colors.orange["300"]};
  }

  &:last-child {
    padding-right: 0px;
  }

  @media ${breakpoints.tablet} {
    padding: 0 32px;
  }
`;

export const ScheduleOldTiming = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.colors.neutral["700"]};
  text-decoration: line-through;
  font-size: ${({ theme }) => theme.fontSizes.xs};

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes.xl};
    line-height: 30px;
  }
`;

export const ScheduleNewTiming = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.orange["300"]};
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 20px;
  display: flex;
  flex-direction: column;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["2xl"]};
    line-height: 40px;
    flex-direction: row;
    gap: 5px;
  }
`;

export const Footer = styled.div`
  margin: 24px 0;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  text-align: center;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes.lg};
  }
`;

export const JadwalChangesContainer = styled.div`
  margin: 40px 0px;
`;
